import useLibraryEnums, { KeyedStringEnum } from "../../../providers/Materials/LibraryEnumsProvider";
import { LCIAResult, NewMaterial } from "../../../types/Views/CreateMaterial/NewMaterial";

const getDefaultLCIAResults = async () => {
  const libraryEnums = useLibraryEnums();
  const indicatorTypeEnums: KeyedStringEnum | undefined = await libraryEnums.getIndicatorTypeEnums();
  const indicatorEnums: KeyedStringEnum | undefined = await libraryEnums.getIndicatorEnums();
  const defaultIndicators: Array<{
    type: string;
    unit: string;
    originalIdentifier?: string;
    value: number | null;
  }> = [];

  const lciaResults: Array<LCIAResult> = [];
  if (indicatorTypeEnums) {
    Object.entries(indicatorTypeEnums).forEach(([key, value]: any) => {
      const indicator = {
        type: key,
        originalIdentifier: value,
        unit: indicatorEnums ? indicatorEnums[value] : "",
        value: null,
      };

      defaultIndicators.push(indicator);
    });
  }

  for (let i = 0; i < 18; i++) {
    const lciaResult: LCIAResult = {
      moduleStatusEnum: 0,
      moduleTypeEnum: i,
      indicators: structuredClone(defaultIndicators),
    };
    lciaResults.push(lciaResult);
  }

  return lciaResults;
};

export const materialTemplate: NewMaterial = {
  tenantId: "0",
  isPublic: false,
  isCustom: true,
  expectedLifespan: null,
  name: "",
  description: "",
  biogenicParams: null,
  lciaResults: [],
  declaredUnit: {
    declaredUnit: -1,
    declaredValue: null,
    mass: null,
    massUnit: -1,
  },
  epdInfo: {
    epdSpecificationForm: -1,
    epdProductIndustryType: -1,
    publicationDate: "",
    validTo: "",
    declarationOwnerId: "",
    link: "",
    dataSourceIds: [],
    fileEntityId: "",
    epdVersion: "",
    declarationNumber: "",
  },
  tags: [],
};

export const getMaterialTemplate = async () => {
  const newTemplate = JSON.parse(JSON.stringify(materialTemplate));
  newTemplate.lciaResults = await getDefaultLCIAResults();

  return newTemplate;
};

export { getDefaultLCIAResults };
